import VisitService from 'Services/VisitService'
import IssueService from 'Services/IssueService'
import PatientService from 'Services/PatientService'

import moment from 'moment'

export default {

    state: {
        visits: {},
        issue: {},
        patient: {}
    },

    namespaced: true,

    getters: {
        visits: state => state.visits,
        issue: state => state.issue,
        patient: state => state.patient
    },

    mutations: {
        SET_VISITS(state, visits) {
            visits.data = visits.data.map((visit) => {
                return {
                    id: visit.id,
                    date: moment(visit.event.start).format('DD.MM.YYYY'),
                    hours: moment(visit.event.start).format('HH:mm') + ' - ' + moment(visit.event.end).format('HH:mm'),
                    type: (visit.event.type === 'office') ? 'W gabinecie' : 'Domowa',
                    location: ((visit.event.office_id !== null) ? visit.event.office.name : visit.event.mobile_city) || '-',
                    status: (visit.status === 'completed') ? 'Zrealizowana' : 'W toku',
                    p1_report_status: (visit.latest_p1_integration_medical_event_report && visit.latest_p1_integration_medical_event_report.status) ? visit.latest_p1_integration_medical_event_report.status : null,
                    p1_report_info: (visit.latest_p1_integration_medical_event_report && visit.latest_p1_integration_medical_event_report.user_log) ? visit.latest_p1_integration_medical_event_report.user_log : null,
                    p1_report_updated_at: (visit.latest_p1_integration_medical_event_report && visit.latest_p1_integration_medical_event_report.updated_at) ? formatIsoDate(visit.latest_p1_integration_medical_event_report.updated_at) : null,
                    actionLabel: (visit.status === 'completed') ? 'Edytuj' : 'Kontynuuj'
                }
            })
            state.visits = visits
        },
        SET_ISSUE(state, issue) {
            state.issue = issue
        },
        SET_PATIENT(state, patient) {
            state.patient = patient
        }
    },

    actions: {
        FETCH_VISITS({commit}, payload) {
            return VisitService.list({
                issue_id: payload.issueId,
                with: 'event.office',
                paginate: 1,
                page: payload.page
            }).then((response) => {
                commit('SET_VISITS', response.data.data)
                return response
            })
        },
        FETCH_ISSUE({commit}, issueId) {
            return IssueService.get(issueId).then((result) => {
                commit('SET_ISSUE', result.data.data)
                return result
            })
        },
        UPDATE_ISSUE({commit}, payload) {
            return IssueService.update(payload).then((response) => {
                commit('SET_ISSUE', response.data.data)
                return response
            })
        },
        REMOVE_ISSUE(context, issueId) {
            return IssueService.delete(issueId)
        },
        FETCH_PATIENT({commit}, patientId) {
            return PatientService.get(patientId).then((response) => {
                commit('SET_PATIENT', response.data.data)
                return response
            })
        },
        REMOVE_VISIT({state, dispatch}, visitId) {
            return VisitService.delete(visitId).then((response) => {
                dispatch('FETCH_VISITS', {
                    issueId: state.issue.id,
                    page: state.visits.current_page
                })
                return response
            })
        }
    }

}

function formatIsoDate(isoDate) {
    const date = new Date(isoDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
}
